import { render, staticRenderFns } from "./addTratamentModal.vue?vue&type=template&id=1ecde3e8"
import script from "./addTratamentModal.vue?vue&type=script&lang=js"
export * from "./addTratamentModal.vue?vue&type=script&lang=js"
import style0 from "./addTratamentModal.vue?vue&type=style&index=0&id=1ecde3e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports